import { PrimaryButton } from "office-ui-fabric-react";
import Papa from "papaparse";
import { models, Report } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Select, { createFilter } from "react-select";
import { Config } from "react-select/src/filters";
import { handleAxiosError } from "store/util";
import { getPowerBIEmbedMeta } from "../../store/api/api";
import { AppDispatch } from "../../store/store";
import { PowerBIEmbedMeta } from "../../types/types";

let pagastsList = [];
let fieldsList = [];

export const InsurerReportPage = () => {
  const [
    embedMetadata = { reportId: null, accessToken: null, embedUrl: "" },
    setEmbedMetadata,
  ] = useState<PowerBIEmbedMeta>();
  const [report, setReport] = useState<Report>();
  const dispatch: AppDispatch = useDispatch();
  const [reportType, setReportType] = useState<string>();
  const { t } = useTranslation();

  const [pagasts, setPagasts] = React.useState([]);
  const [years, setYears] = React.useState([]);

  const [selectedPagast, setSelectedPagast] = React.useState(null);
  const [selectedYears, setSelectedYears] = React.useState(null);

  const [reportStatus, setReportStatus] = React.useState("loaded");
  const [errorMessage, setErrorMessage] = React.useState(null);

  React.useEffect(() => {
    let yearsList = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2007; year--) {
      yearsList.push({ value: year + "", label: year + "" });
    }
    setYears(yearsList);
  }, []);
  React.useEffect(() => {
    const csv = "/Pagasts.csv";
    Papa.parse(csv, {
      header: true,
      download: true,
      complete: (response) => {
        pagastsList = response.data;
        setPagasts(
          pagastsList.map((el) => {
            return { value: el.LABELID, label: el.LABEL };
          })
        );
      },
    });
  }, []);

  React.useEffect(() => {
    const csv = "/Fields.csv";
    Papa.parse(csv, {
      header: true,
      download: true,
      complete: (response) => {
        fieldsList = response.data;
      },
    });
  }, []);

  const refreshToken = useCallback(() => {
    (async () => {
      let parameters = {
        filter: ``,
      };
      const refreshEmbedObj: any = await getPowerBIEmbedMeta(
        "insurer",
        parameters
      );
      if (report) {
        report.setAccessToken(refreshEmbedObj.data.accessToken);
      }
      setTimeout(refreshToken, 55 * 60 * 1000); // wait 55 minutes before refreshing token
    })();
  }, []);

  const changePagast = (selection) => {
    setSelectedPagast(pagastsList.find((el) => el.LABELID === selection.value));
  };

  const submitCalculation = () => {
    setReportStatus("loading");
    (async () => {
      let parameters = {
        filter: `Pagasts/LABELID in (${
          selectedPagast.LABELID
        }) and Calendar/Date ge datetime'${
          selectedYears[0].value
        }-01-01T00:00:00' and Calendar/Date lt datetime'${
          parseInt(selectedYears[0].value) + 1
        }-01-01T00:00:00'`,
      };
      try {
        const embedObj: any = await getPowerBIEmbedMeta("insurer", parameters);
        setEmbedMetadata(embedObj.data);
      } catch (err) {
        setErrorMessage(handleAxiosError(err));
        handleAxiosError(err);
        setReportStatus("loaded");
      }
    })();
    setTimeout(refreshToken, 55 * 60 * 1000); // wait 55 minutes before refreshing token
  };

  useEffect(() => {
    let items = fieldsList.filter((el) => {
      return el.LABELID === selectedPagast.LABELID;
    });

    items = items.map((el2) => {
      return { value: el2.ID, label: el2.BLOCK_NUMB };
    });
  }, [selectedPagast]);

  const powerBiReport = useMemo(() => {
    return (
      <PowerBIEmbed
        eventHandlers={
          new Map([
            [
              "loaded",
              function () {
                setReportStatus("loaded");
              },
            ],
            [
              "rendered",
              function () {
                setReportStatus("rendered");
              },
            ],
            [
              "error",
              function (event) {
                setReportStatus("error");
              },
            ],
          ])
        }
        embedConfig={{
          type: "report",
          id: embedMetadata.reportId,
          embedUrl: embedMetadata.embedUrl,
          accessToken: embedMetadata.accessToken,
          tokenType: models.TokenType.Embed,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: false,
          },
        }}
        cssClassName={"analytics-report-class"}
        getEmbeddedComponent={(embeddedReport) => {
          setReport(embeddedReport as Report);
        }}
      />
    );
  }, [
    embedMetadata.accessToken,
    embedMetadata.embedUrl,
    embedMetadata.reportId,
  ]);
  const filterConfig: Config = {
    ignoreCase: false,
    ignoreAccents: false,
    trim: false,
    matchFrom: "start",
  };
  return (
    <div style={{ display: "flex" }}>
      <div style={{ flex: 2 }}>
        <div
          style={{ display: "flex", flexDirection: "column", padding: "20px" }}
        >
          <label
            style={{
              width: "100%",
              flex: 1,
              margin: "10px",
              fontWeight: "bold",
            }}
          >
            County
          </label>
          <Select options={pagasts} onChange={changePagast} />

          <label
            style={{
              width: "100%",
              flex: 1,
              margin: "10px",
              fontWeight: "bold",
            }}
          >
            Year
          </label>
          <Select
            options={years}
            value={selectedYears}
            onChange={(el) => setSelectedYears([el as any])}
            isDisabled={selectedPagast === null}
            filterOption={createFilter(filterConfig)}
          />
          <PrimaryButton
            style={{ marginTop: "30px" }}
            text={reportStatus !== "loading" ? "Display Report" : "Loading..."}
            disabled={
              reportStatus === "loading" || !selectedPagast || !selectedYears
            }
            onClick={submitCalculation}
          />
          <span style={{ marginTop: "30px", color: "red" }}>
            {errorMessage}
          </span>
        </div>
      </div>
      <div
        style={{
          flex: 8,
        }}
      >
        {powerBiReport}
      </div>
    </div>
  );
};
